import { axios } from 'lib/axios';

export const loginWithEmailOTP = async (data) => {
  return await axios.post('/user/emailOTPLogin/login', data);
};
